import { createModel } from '@/store/tools';

const model = {
    namespace: 'parameter',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getlistComplaintReasons': T('getlistComplaintReasons'),//获取投诉原因配置列表
            'getlistCancelReasons': T('getlistCancelReasons'), // 获取取消原因列表
            'getlistAppealReasons': T('getlistAppealReasons'), // 获取申诉理由列表
            'getParamValueByCode': T('getParamValueByCode'), // 根据code获取系统参数值
            'getlistExceptionTypes': T('getlistExceptionTypes'), // 获取异常类型配置列表
            'getlistVoicePacket': T('getlistVoicePacket'), // 获取语音包列表
            'getlistAdminParamByParamType': T('getlistAdminParamByParamType'), // 根据参数类型paramType获取参数列表
            'getlist': T('getlist'), // 查询惩罚原因列表
        },
        actions: {
             'getlistComplaintReasons': A('getlistComplaintReasons'), // 获取投诉原因配置列表
             'getlistCancelReasons': A('getlistCancelReasons'), // 获取取消原因列表
             'getlistAppealReasons': A('getlistAppealReasons'), // 获取申诉理由列表
             'getParamValueByCode': A('getParamValueByCode'), // 根据code获取系统参数值
             'getlistExceptionTypes': A('getlistExceptionTypes'), // 根据code获取系统参数值
             'getlistVoicePacket': A('getlistVoicePacket'), // 获取语音包列表
             'getlistAdminParamByParamType': A('getlistAdminParamByParamType'), // 获取语音包列表
             'getlist': A('getlist'), // 查询惩罚原因列表
        },
        sagas: {
            'getlistComplaintReasons': S('getlistComplaintReasons', '/?cmd=com.xqxc.api.pig.mis.biz.platform.ComplaintReasonsMisService.listComplaintReasons'),
            'getlistCancelReasons': S('getlistCancelReasons', '/?cmd=com.xqxc.api.pig.mis.biz.platform.CancelReasonsMisService.listCancelReasons'),
            'getlistAppealReasons': S('getlistAppealReasons', '/?cmd=com.xqxc.api.pig.mis.biz.rider.AppealReasonsMisService.listAppealReasons'),
            'getParamValueByCode': S('getParamValueByCode', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.getParamValueByCode'),
            'getlistExceptionTypes': S('getlistExceptionTypes', '/?cmd=com.xqxc.api.pig.mis.biz.platform.ExceptionTypesMisService.listExceptionTypes'),
            'getlistVoicePacket': S('getlistVoicePacket', '/?cmd=com.xqxc.api.pig.mis.biz.platform.VoicePacketMisService.listVoicePacket'),
            'getlistAdminParamByParamType': S('getlistAdminParamByParamType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.listAdminParamByParamType'),
            'getlist': S('getlist', '/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.list'),
        },
        reducers: {
            'listComplaintReasons': R('getlistComplaintReasons', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'listCancelReasons': R('getlistCancelReasons', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'listAppealReasons': R('getlistAppealReasons', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'ParamValueByCode': R('getParamValueByCode', 0),
            'listExceptionTypes': R('getlistExceptionTypes', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'listVoicePacket': R('getlistVoicePacket', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'listAdminParamByParamType': R('getlistAdminParamByParamType', []),
            'list': R('getlist', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);